import { DateTime } from 'luxon';
export const isStartTimeBeforeEndTime = (
  startTime: string,
  endTime: string
) => {
  if (!endTime) return true;
  const diff = DateTime.fromISO(startTime).diff(DateTime.fromISO(endTime));
  return diff.milliseconds < 0 || 'Start Time must be before End Time';
};
